import { koComponent } from "../../ko-utils";
import $api from "../../api";

class CompanyAutoJoinView {
  constructor(params, parentPage) {
    this.joins = ko.observableArray();

    this.parentPage = parentPage;

    this.ButtonLock = ko.observable(false);

    this.isAutoJoin = ko.observable(this.getServerSideData("isAutoJoin"));

    this.domains = this.getDomainString();

    this.hasWorkDomain = this.getServerSideData("hasWorkDomain");

    this.isLoaded = ko.observable(false);

    this.ButtonLock = ko.observable(false);

    this.isAutoJoin.subscribe((value) => {
      this.updateJoinOption(value, this.isAutoJoin);
    });

    this.load();
  }

  updateJoinOption(value, join) {
    join(value);

    if (ko.unwrap(this.ButtonLock)) {
      return;
    }

    this.ButtonLock(true);

    $api.company.setAutoJoin(
      {},
      {
        Enabled: ko.unwrap(value),
      },
      (resp) => {
        if (resp) {
          if (resp.success) {
            if (resp.isEnabled) join(resp.isEnabled);

            this.parentPage.showToast(
              `Automatic approval ${resp.isEnabled ? "enabled" : "disabled"}`
            );
          }
        }
      }
    );

    setTimeout(() => {
      this.ButtonLock(false);
    }, 500);
  }

  getDomainString() {
    var array = this.getServerSideData("domains");

    var domains_str = "";

    var index = 0;

    for (const domain of array) {
      if (index == 0) {
        domains_str = domain;
      } else {
        domains_str += `, ${domain}`;
      }

      index++;
    }

    return domains_str;
  }

  /**
   * @param {any} key
   */
  getServerSideData(key) {
    if (window.serverSide) {
      return window.serverSide[key];
    }
  }

  load() {
    this.isLoaded(true);
  }

  update(join) {}
}

export default koComponent("company-autojoin-view", CompanyAutoJoinView);
